export const Dash: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path fill="#FDFDFD" d="M11 7H5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2"></path>
  </svg>
);
